<template>
  <div class="location-wrapper">
    <!-- <h2>Vue 2 Geolocation</h2> -->
    
    <!-- <button @click="getLocation" :disabled="loading">
      {{ loading ? 'Locating...' : 'Get My Location' }}
    </button> -->

    <!-- <div v-if="location" class="results">
      <p><strong>Latitude:</strong> {{ location.latitude }}</p>
      <p><strong>Longitude:</strong> {{ location.longitude }}</p>
    </div>

    <p v-if="error" class="error">{{ error }}</p> -->
  </div>
</template>

<script>
import http from '@/components/services/http-common'

export default {
  data() {
    return {
      location: null,
      error: null,
      loading: false
    };
  },
  methods: {
    getLocation() {
      this.loading = true;
      this.error = null;

      if (!("geolocation" in navigator)) {
        this.error = "Geolocation is not supported by your browser.";
        this.loading = false;
        return;
      }

      // options: enableHighAccuracy, timeout, maximumAge
      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      };

      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.location = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          };
          
          http.post(`departments/geolocation?lat=${this.location.latitude}&lon=${this.location.longitude}` )

          this.loading = false;
        },
        (err) => {
          this.loading = false;
          this.error = `Error: ${err.message}`;
        },
        options
      );
    }
  },
  mounted() {
    this.getLocation()
  }
};
</script>

<style scoped>
.error { color: red; }
.results { margin-top: 20px; }
</style>